<template>
  <div class="scenario_result scenario_result_buyHouse">
    <div class="s-result_top houseemod">
      <div class="container">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/">首頁</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{name:'needs_analysis'}">人生藍圖計算機</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{name: 'buyHouse'}">買房試算</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">試算結果</li>
          </ol>
        </nav>
        <div class="s-result_top--img">
          <img src="@/assets/images/needs/banner-house/form_house.svg" alt="">
        </div>
        <div class="s-result_top--text">

          <h3>根據分析結果你理想中的房子</h3>
          <div id="myTab" class="result_top_tab" role="tablist">
            <div class="result_top_tab">
              <ul class="tab_outter">
                <li
                    @click="requiredMoneyToggle('all')"
                    :class="{active: view === 'all'}">
                  <a class="tab">總價</a>
                </li>
                <li
                    @click="requiredMoneyToggle('own')"
                    :class="{active: view === 'own'}">
                  <a class="tab">自備款</a>
                </li>
              </ul>
            </div>
            <div class="tab-content" id="myTabContent">
              <transition name="component-fade" mode="out-in">
                <component :is="view" :totalPayment="totalPayment" :downPayment="downPayment"></component>
              </transition>
            </div>
          </div>
        </div>

        <div class="s-result_top--btn row">
          <div class="col-xs-6 col-md-2 col-md-offset-4 form-group">
            <div class="share_btn share_btn_peach">
              <router-link :to="{name:'buyHouse_form'}">重新試算</router-link>
            </div>
          </div>
          <div class="col-xs-6 col-md-2 form-group">
            <div class="share_btn share_btn_peachDefault">
              <a class="click_needs_analysis_consult_top"
                @click="toForm('專人諮詢', '')">我想了解</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="s-result_content">
      <div class="container">
        <h3 class="title_tip">買房第一步：自備款 <i class="fas fa-question-circle"><span class="tip_content">自備款 = 頭期款 + 裝潢費<br>
              若無裝潢費，此處自備款即等於頭期款哦～</span></i></h3>
        <div class="s-result_content--chart">
          <div class="chart_wrap_list">
            <div class="donuts_chart">
              <div class="donuts_chart_rate">
                <span class="percent">{{ achievementRate }}%</span>
                <p class="rate_tip"><b>買房第一步達成率</b> <i class="fas fa-question-circle">
                  <span class="tip_content">意即你目前的【頭期款+裝潢費】達成率。</span>
                </i></p>
              </div>
            </div>
            <div class="chart_list">
              <div class="formula_summary_line">
                <div class="summary_border">
                  <div class="title_coin">
                    <img src="@/assets/images/needs/banner-retire/coin.svg" alt="">
                  </div>
                  <div class="formula_title">
                    <b>買房自備款試算結果</b>
                  </div>
                  <div class="sup_switch blackmod" @click="openPopup('#Popup__formAdd1')">
                    <a class="click_needs_analysis_tuneSpent"><i class="fas fa-sliders-h"></i> 調整花費</a>
                  </div>
                </div>
                <Popup ref="popup" :pop-value="popValue"></Popup>
              </div>

              <div class="formula_content">
                <ul>
                  <li>
                    <div class="content_icon">
                      <i class="fas fa-hand-holding-usd"></i>
                    </div>
                    <div class="content_title">
                      目前已備資金
                    </div>
                    <div class="content_cost">
                      <b>{{ alreadyPrepare | currency }} <span>元</span></b>
                    </div>
                  </li>
                  <li>
                    <div class="content_icon">
                      <i class="fas fa-coins"></i>
                    </div>
                    <div class="content_title">
                      距離存到自備款還差
                    </div>
                    <div class="content_cost">
                      <b>{{ downPaymentStillNeed | currency }} <span>元</span></b>
                    </div>
                  </li>
                  <li>
                    <div class="content_icon">
                      <i class="fas fa-piggy-bank"></i>
                    </div>
                    <div class="content_title">
                      達成自備款建議再存
                    </div>
                    <div class="content_cost">
                      <b>{{ suggestSavePerMoney | currency }} <span>元／月</span></b>
                    </div>
                  </li>
                </ul>
              </div>

            </div>
          </div>
        </div>

      </div>
    </div>
    <div
        v-if="achievementRate < 100"
        class="s-result_sup">
      <div class="container">
        <h3>買房第二步：實踐買房夢想</h3>
        <p>想盡早實現買房藍圖，現在就開始著手吧！<br>快看看我們為你精心挑選的方案</p>
        <div class="sup_part">
          <div class="owl-carousel owl-theme">
            <div class="sup_block_wrap item">
              <div class="sup_block">
                <h4>方案一</h4>
                <div class="sup_block--w savemod">
                  <div class="currency_sticker">
                    <div class="currency_tip NTD">
                      台幣保單
                    </div>
                  </div>

                  <div class="sup_rate">
                    <p>報酬率</p>
                    <span class="rate_gap">{{ t_returnRate }}%</span>
                  </div>

                  <div class="sup_count">
                    <div class="count_each">
                      <p class="count_each--item">從現在連續 {{ t_saveInRowYear }} 年存</p>
                      <p class="count_each--num">{{ t_saveInRowAmount | currency }}<span> 元</span>
                      </p>
                    </div>
                    <div class="count_each">
                      <p class="count_each--item">第 {{ yearGetBack }} 年可領回</p>
                      <p class="count_each--num">{{ t_getAmount | currency }}<span> 元</span>
                      </p>
                    </div>
                    <div class="count_each">
                      <p class="count_each--item">達成率提升至</p>
                      <div class="count_each--progress">
                        <div class="progress_mix">
                          <div class="progress_bar" role="progressbar"
                               :style="{width: (achievementRate + t_raisedAchievementRate > 100 ? 100 : achievementRate) + '%' }"></div>
                          <div class="progress_bar bar_fill" role="progressbar"
                               :style="{width: t_raisedAchievementRate + '%' }"></div>
                        </div>
                        <label class="progress_num">{{ achievementRate + t_raisedAchievementRate }}%</label>
                      </div>

                    </div>

                    <div class="count_each reasonmod">
                      <p class="count_each--item">方案說明</p>
                      <p class="count_each--num"><i class="fas fa-chevron-down"></i></p>
                      <p class="count_each--text">
                        利用儲蓄險強迫儲蓄，並將未來的利率鎖定在現在，不受利率下跌影響的特性來規劃買房自備款，是確保資金穩健性的好辦法！此方案能有效避免自備款受到投資風險的損害，又因是為台幣保單，故無匯率風險。
                      </p>
                    </div>
                  </div>

                  <div class="col-md-8 col-md-offset-2 share_btn share_btn_peachDefault">
                    <a class="click_needs_analysis_consultPlan_1" @click="toForm('方案一(台幣儲蓄險)', t_productName)">我想了解</a>
                  </div>


                </div>
              </div>
            </div>
            <div class="sup_block_wrap item">
              <div class="sup_block">
                <h4>方案二</h4>
                <div class="sup_block--w savemod">
                  <div class="currency_sticker">
                    <div class="currency_tip USD">
                      美元保單
                    </div>
                  </div>

                  <div class="sup_rate">
                    <p>報酬率</p>
                    <span class="rate_gap">{{ u_returnRate }}%</span>
                  </div>

                  <div class="sup_count">
                    <div class="count_each">
                      <p class="count_each--item">從現在連續 {{ u_saveInRowYear }} 年存</p>
                      <p class="count_each--num">{{ u_saveInRowAmount | currency }}<span> 元</span>
                      </p>
                    </div>
                    <div class="count_each">
                      <p class="count_each--item">第 {{ yearGetBack }} 年可領回</p>
                      <p class="count_each--num">{{ u_getAmount | USD_currency }}<span> 元</span>
                      </p>
                    </div>
                    <div class="count_each">
                      <p class="count_each--item">達成率提升至</p>
                      <div class="count_each--progress">
                        <div class="progress_mix">
                          <div class="progress_bar" role="progressbar"
                               :style="{width: (achievementRate + u_raisedAchievementRate > 100 ? 100 : achievementRate) + '%' }"></div>
                          <div class="progress_bar bar_fill" role="progressbar"
                               :style="{width: u_raisedAchievementRate + '%' }"></div>
                        </div>
                        <label class="progress_num">{{ achievementRate + u_raisedAchievementRate }}%</label>
                      </div>

                    </div>

                    <div class="count_each reasonmod">
                      <p class="count_each--item">方案說明</p>
                      <p class="count_each--num"><i class="fas fa-chevron-down"></i></p>
                      <p class="count_each--text">
                        想存下買房自備款的首要重點在於資金的穩健性，要避免好不容易存下的購屋基金，因投資風險而受損，利用儲蓄險進行規劃是個不錯的好選擇！原因不外乎儲蓄險能強迫儲蓄，並將未來的利率鎖定在現在，不會受到利率下跌的影響。但是，美金的儲蓄險還是有匯率風險，要注意一下最終解約時的匯率，才能避免虧損哦！
                      </p>
                    </div>
                  </div>

                  <div class="col-md-8 col-md-offset-2 share_btn share_btn_peachDefault">
                    <a class="click_needs_analysis_consultPlan_2" @click="toForm('方案二(美元儲蓄險)', u_productName)">我想了解</a>
                  </div>
                </div>
              </div>
            </div>


            <div class="sup_block_wrap bigpresentmod item">
              <div class="sup_block peachmod">
                <h4>方案三</h4>
                <div class="sup_block--w sup_block--h savemod">

                  <div class="center_layout">
                    <div class="center_img">
                      <img src="@/assets/images/needs/banner-house/support.svg" alt="">
                    </div>
                    <p class="count_each--text">
                      利用上述的試算結果，搭配專人的客觀解析，必定能為你找出實踐買房夢想，最合適的方法！
                    <div class="col-md-8 col-md-offset-2 share_btn share_btn_peachDefault">
                      <a class="click_needs_analysis_consultPlan_3" @click="toForm('方案三', '')">我想了解</a>
                    </div>

                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div
        v-else
        class="s-result_sup">
      <div class="container">
        <h3>買房第二步：實踐買房夢想</h3>
        <p>想盡早實現買房藍圖，現在就開始著手吧！<br>快看看我們為你精心挑選的方案</p>
        <div class="sup_part">
          <div class="owl-carousel owl-theme">
            <div class="sup_block_wrap item">
              <div class="sup_block">
                <h4>方案一</h4>
                <div class="sup_block--w savemod">
                  <div class="currency_sticker">
                    <div class="currency_tip RCD">
                      推薦保單
                    </div>
                  </div>

                  <div class="sup_rate">
                    <p>此方案年保費</p>
                    <span class="rate_gap">{{ premium_1 | currency }}</span>

                  </div>
                  <div class="sup_count">
                    <div class="count_each">
                      <p class="count_each--item">意外失能</p>
                      <p class="count_each--num">3,000,000<span> 元</span>
                      </p>
                    </div>
                    <div class="count_each">
                      <p class="count_each--item">意外實支實付</p>
                      <p class="count_each--num">100,000<span> 元</span>
                      </p>
                    </div>
                    <div class="count_each">
                      <p class="count_each--item">醫療實支實付</p>
                      <p class="count_each--num">250,000<span> 元</span>
                      </p>
                    </div>
                    <div class="count_each reasonmod">
                      <p class="count_each--item">方案說明</p>
                      <p class="count_each--num"><i class="fas fa-chevron-down"></i>
                      <p>
                      <p class="count_each--text">
                        為自己把醫療資源及早準備好，才不用擔心因疾病或意外，動用到好不容易存下的買房自備款！利用意外險及醫療險作為後勤支柱，建立足夠的風險保障，便不用擔心自己有天成為家人的負擔，或生活發生重大變故了。
                      </p>
                    </div>
                  </div>

                  <div class="col-md-8 col-md-offset-2 share_btn share_btn_peachDefault">
                    <a class="click_needs_analysis_consultPlan_1" @click="toForm('方案一 (意外加醫療險)', product_id_1)">我想了解</a>
                  </div>


                </div>
              </div>
            </div>

            <div class="sup_block_wrap item">
              <div class="sup_block">
                <h4>方案二</h4>
                <div class="sup_block--w savemod">
                  <div class="currency_sticker">
                    <div class="currency_tip RCD">
                      推薦保單
                    </div>
                  </div>

                  <div class="sup_rate">
                    <p>此方案年保費</p>
                    <span class="rate_gap">{{ premium_2 | currency }}</span>

                  </div>
                  <div class="sup_count">
                    <div class="count_each">
                      <p class="count_each--item">意外失能</p>
                      <p class="count_each--num">3,000,000<span> 元</span>
                      </p>
                    </div>
                    <div class="count_each">
                      <p class="count_each--item">意外實支實付</p>
                      <p class="count_each--num">100,000<span> 元</span>
                      </p>
                    </div>
                    <div class="count_each reasonmod">
                      <p class="count_each--item">方案說明</p>
                      <p class="count_each--num"><i class="fas fa-chevron-down"></i>
                      <p>
                      <p class="count_each--text">
                        每當意外發生時，總是擔心自己成為家人的負擔，或是因為自己沒辦法給寶貝們最好的教育，但是有了足夠的風險保障，就再也不用擔心生活發生變故了。利用意外險及醫療險作為後勤支柱。 </p>
                    </div>
                  </div>
                  <div class="col-md-8 col-md-offset-2 share_btn share_btn_peachDefault">
                    <a class="click_needs_analysis_consultPlan_2" @click="toForm('方案二 (意外險)', product_id_2)">我想了解</a>
                  </div>


                </div>
              </div>
            </div>

            <div class="sup_block_wrap bigpresentmod item">
              <div class="sup_block peachmod">
                <h4>方案三</h4>
                <div class="sup_block--w sup_block--h savemod">

                  <div class="center_layout">
                    <div class="center_img">
                      <img src="@/assets/images/needs/banner-house/support.svg" alt="">
                    </div>
                    <p class="count_each--text">
                      利用上述的試算結果，搭配專人的客觀解析，必定能為你找出實踐買房夢想，最合適的方法！
                    <div class="col-md-8 col-md-offset-2 share_btn share_btn_peachDefault">
                      <a class="click_needs_analysis_consultPlan_3" @click="toForm('方案三', '')">我想了解</a>
                    </div>

                  </div>

                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/scenario_buyHouse.css'
import Popup from "@/components/common/popup";
import {get} from "vuex-pathify";

export default {
  name: "buy_house_result",
  components: {
    'all': {
      template: `
        <div>
        <p>{{ totalPayment | tenThousandCurrency }}<span> 萬元</span></p>
        <span class="total_formula">總價 = 頭期款 + 裝潢費 + 房貸</span>
        </div>`,
      props: {
        totalPayment: Number
      },
      filters: {
        tenThousandCurrency(value) {
          var num = (Math.round(value / 10000) || 0).toString(), result = '';
          while (num.length > 3) {
            result = ',' + num.slice(-3) + result;
            num = num.slice(0, num.length - 3);
          }
          if (num) {
            result = num + result;
          }
          if (!result.indexOf('-,')) result = result.replace('-,', '-')
          return result;
        },
      }
    },
    'own': {
      template: `
        <div>
        <p> {{ downPayment | tenThousandCurrency }} <span> 萬元</span></p>
        <span class="total_formula">自備款 = 頭期款 + 裝潢費</span>
        </div>`,
      props: {
        downPayment: Number
      },
      filters: {
        tenThousandCurrency(value) {
          var num = (Math.round(value / 10000) || 0).toString(), result = '';
          while (num.length > 3) {
            result = ',' + num.slice(-3) + result;
            num = num.slice(0, num.length - 3);
          }
          if (num) {
            result = num + result;
          }
          if (!result.indexOf('-,')) result = result.replace('-,', '-')
          return result;
        },
      }
    },
    Popup,
  },
  data: function () {
    return {
      product_id_1: '70bdb9ef4a7a7cd1b1c009ae1667b146',
      product_id_2: '7116ec4f16016a88d94bb8f1934f8f82',
      popValue: {
        min: 0,
        max: 10000000,
      },
      view: 'own'
    }
  },
  computed: {
    ...get('buyHouse', {
      totalPayment: 'result@totalPayment',
      downPayment: 'result@downPayment',
      downPaymentStillNeed: 'result@downPaymentStillNeed',
      suggestSavePerMoney: 'result@suggestSavePerMoney',
      achievementRate: 'result@achievementRate',
      alreadyPrepare: 'result@alreadyPrepare',
      t_raisedAchievementRate: 'result@t_raisedAchievementRate',
      t_returnRate: 'result@t_returnRate',
      t_saveInRowAmount: 'result@t_saveInRowAmount',
      t_saveInRowYear: 'result@t_saveInRowYear',
      t_productName: 'result@tripleIData.t_productName',
      t_getAmount: 'result@t_getAmount',
      u_productName: 'result@tripleIData.u_productName',
      u_getAmount: 'result@u_getAmount',
      u_raisedAchievementRate: 'result@u_raisedAchievementRate',
      u_returnRate: 'result@u_returnRate',
      u_saveInRowAmount: 'result@u_saveInRowAmount',
      u_saveInRowYear: 'result@u_saveInRowYear',
      yearGetBack: 'result@yearGetBack',
      premium_1: 'result@premium_1',
      premium_2: 'result@premium_2',
    }),
  },
  created() {
    this.setData()
  },
  mounted() {
    this.setOwlCarousel()
    this.textToggle()
  },
  methods: {
    async setData() {
      let token = this.$route.params.token
      await store.dispatch('buyHouse/getSBBuyHouseData', token)
      if (!store.get('buyHouse@result.hasData')) {
        await this.$router.push({name: 'buyHouse'})
      }
    },
    requiredMoneyToggle(selected) {
      this.view = selected;
    },
    async toForm(plan, productName) {
      let planObj = {
        name: plan,
        product: productName
      }
      let token = this.$route.params.token
      await store.dispatch('buyHouse/updateSBBuyHouseData', {planObj, token})
    },
    openPopup(popupId) {
      if (popupId === '#Popup__formAdd1') {
        this.$refs.popup.openAddPopup(popupId)
        this.$refs.popup.setBarRange()
      }
    },
    setOwlCarousel() {
      $('.owl-carousel').owlCarousel({
        loop: false,
        margin: 10,
        nav: false,
        dots: true,
        responsive: {
          0: {
            items: 1,
            mouseDrag: true,
            touchDrag: true,
            dots: true,
          },
          768: {
            items: 2,
            mouseDrag: true,
            touchDrag: true,
            dots: true,
          },
          1200: {
            items: 3,
            loop: false,
            mouseDrag: false,
            touchDrag: false,
            dots: false,
          }
        }
      })
    },
    textToggle() {
      $('.reasonmod').on('click', function () {
        $(this).toggleClass('text-open')
      });
    }
  },
  filters: {
    currency(value) {
      var num = (value || 0).toString(), result = '';
      while (num.length > 3) {
        result = ',' + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
      }
      if (num) {
        result = num + result;
      }
      if (!result.indexOf('-,')) result = result.replace('-,', '-')
      return result;
    },
    USD_currency(value) {
      var num = (value * 28 || 0).toString(), result = '';
      while (num.length > 3) {
        result = ',' + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
      }
      if (num) {
        result = num + result;
      }
      if (!result.indexOf('-,')) result = result.replace('-,', '-')
      return result;
    },
  }
}
</script>

<style scoped>
.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity .3s ease;
}

.component-fade-enter, .component-fade-leave-to
  /* .component-fade-leave-active for below version 2.1.8 */
{
  opacity: 0;
}
</style>
